// @flow

export const KEY_PREFIX = 'persist:'
export const FLUSH = 'persist/FLUSH'
export const REHYDRATE = 'persist/REHYDRATE'
export const PAUSE = 'persist/PAUSE'
export const PERSIST = 'persist/PERSIST'
export const PURGE = 'persist/PURGE'
export const REGISTER = 'persist/REGISTER'
export const DEFAULT_VERSION = -1
